export default "__VITE_ASSET__Bhp06zrF__"